import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { MenuButton } from '@reach/menu-button';
import '@reach/menu-button/styles.css';
import PropTypes from 'prop-types';

import { Avatar, AvatarTeam } from '../Avatars';
import { Icon } from '../Icons';

import './styles/buttonStyles.css';

//  This component should be deprecated in favor of the <MenuButton/> in the __pds folder, however the custom styling, and integrations with downshift, informed, etc
//  requires it to have its own custom component. Even though React 18 is technically incompatible with reach UI's portals, we will be using this component in Phoebe because its placement does
//  does not result in buggy behavior. We will remove it when pds does a complete overhaul.

const GlobalPrimaryContextButton = ({
  ariaLabel,
  children,
  disabled,
  imgSrc,
  imgAltText,
  isPersonal,
  ...rest
}) => (
  <MenuButton
    aria-label={ariaLabel}
    className="button-subtle"
    disabled={disabled}
    {...rest}
  >
    <div className="relative mb-1 h-10">
      {isPersonal ? (
        <Avatar imgAltText={imgAltText} imgSrc={imgSrc} size="xlarge" />
      ) : (
        <AvatarTeam imgAltText={imgAltText} imgSrc={imgSrc} size="xlarge" />
      )}
      <Icon
        aria-hidden
        className="absolute right-2 top-1/2 transform -translate-y-1/2"
        icon={faChevronDown}
      />
    </div>
    {children}
  </MenuButton>
);

GlobalPrimaryContextButton.defaultProps = {
  disabled: false,
  imgAltText: '',
  imgSrc: '',
  isPersonal: false,
};

GlobalPrimaryContextButton.propTypes = {
  /**
   * ARIA label for button
   */
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  /**
   * The disabled state of the button
   */
  disabled: PropTypes.bool,
  /**
   * Alternative text for the icon/avatar
   */
  imgAltText: PropTypes.string,
  /**
   * Image or icon to use other than the default team icon
   */
  imgSrc: PropTypes.string,
  /**
   * Set whether to use a personal avatar image or icon
   */
  isPersonal: PropTypes.bool,
};

export default GlobalPrimaryContextButton;
